import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminUser } from "../../helpers/adminAccess";
import { Routes as AppRoutes } from "../../routes";

export default function RequireAdmin({ children }) {
  if (!isAdminUser()) {
    return <Navigate to={AppRoutes.Orders.path} replace />;
  }
  return children;
}
